module.exports = __webpack_public_path__ + "static/img/avatar_reset.5f3d0a49.png";